<template>
  <v-card flat>
    <v-container>
      <v-form>
        <v-row>
          <v-col cols=12>
            <v-text-field
              label="アプリ内の表示名"
              outlined
              v-model=displayName
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols=12 style="text-align:center">
            <v-btn color="pink" dark @click="onSend">登録する</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
export default {
  computed: {
    displayName: {
      get () {
        return this.$store.state.user.displayName
      },
      set (v) {
        this.$store.commit('user/setDisplayName', v)
      }
    }
  },
  methods: {
    onSend () {
      this.$emit('onMessage', {
        text: '登録しました。'
      })
    }
  }
}
</script>

<style scoped>

</style>
